import declan from "Images/checkout/mobile-male-1-a.png";
import declanDesktop from "Images/checkout/male-1-a.png";
import nick from "Images/checkout/mobile-male-1-b.png";
import nickDesktop from "Images/checkout/male-1-b.png";
import joel from "Images/checkout/mobile-male-2.png";
import joelDesktop from "Images/checkout/male-2.png";
import jj from "Images/checkout/mobile-male-3.png";
import jjDesktop from "Images/checkout/male-3.png";
import m_other from "Images/checkout/mobile-male-4.png";
import m_otherDesktop from "Images/checkout/male-4.png";
import ava from "Images/checkout/mobile-female-1.png";
import avaDesktop from "Images/checkout/female-1.png";
import allie from "Images/checkout/mobile-female-2.png";
import allieDesktop from "Images/checkout/female-2.png";
import taylor from "Images/checkout/mobile-female-3.png";
import taylorDesktop from "Images/checkout/female-3.png";
import f_other from "Images/checkout/mobile-female-4.png";
import f_otherDesktop from "Images/checkout/female-4.png";
import other from "Images/checkout/mobile-nonbinary-other.png";
import otherDesktop from "Images/checkout/nonbinary-other.png";
import original from "Images/checkout/bg.png";
import originalDesktop from "Images/checkout/bg-desk.png";
const header_pics = {
    "declan": {
        mobile: declan,
        desktop: declanDesktop,
    },
    "nick": {
        mobile: nick,
        desktop: nickDesktop,
    },
    "joel": {
        mobile: joel,
        desktop: joelDesktop,
    },
    "jj": {
        mobile: jj,
        desktop: jjDesktop,
    },
    "m_other": {
        mobile: m_other,
        desktop: m_otherDesktop,
    },
    "ava": {
        mobile: ava,
        desktop: avaDesktop,
    },
    "allie": {
        mobile: allie,
        desktop: allieDesktop,
    },
    "taylor": {
        mobile: taylor,
        desktop: taylorDesktop,
    },
    "f_other": {
        mobile: f_other,
        desktop: f_otherDesktop,
    },
    "other": {
        mobile: other,
        desktop: otherDesktop,
    },
    "original": {
        mobile: original,
        desktop: originalDesktop
    }
};
const settings = {
    header_pics,
};
export default settings;
